import { Radio as MUIRadio, styled } from "@mui/material"

export const Radio = styled(MUIRadio)({

})
